<template>
  <v-container
    fill-height
    fluid
    :style="{
      backgroundColor: dark ? 'rgb(40, 40, 40)' : 'inherit',
    }"
  >
    <BlockablesNavbar :show="showNavDrawer" />
    <v-row>
      <v-spacer />
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-row>
          <v-col cols="12" class="pr-6 d-flex align-center justify-end">
            <v-btn
              v-if="!($ark.active || isCoolMath)"
              icon
              @click="$store.commit('USER/ACCOUNT_DIALOG_SET', true)"
            >
              <v-icon :color="dark ? '#fafafa' : $colors.blue">
                {{ icons.account }}
              </v-icon>
            </v-btn>
            <v-btn icon @click="showNavDrawer += 1" class="pl-2">
              <v-icon
                aria-label="Show menu"
                tabindex="-1"
                :color="dark ? '#fafafa' : $colors.blue"
              >
                {{ icons.menu }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-img
              v-if="$ark.active"
              :aspect-ratio="1 / 1"
              height="100"
              alt="Blockables logo"
              contain
              :src="require('@/assets/blockables-arkadium.png')"
              transition="scale-transition"
            />
            <v-img
              v-else
              :aspect-ratio="1 / 1"
              height="100"
              alt="Blockables logo"
              contain
              :src="require('@/assets/blockables-square.png')"
              transition="scale-transition"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="d-flex align-center justify-center"
            :class="author ? 'pb-2' : ''"
          >
            <span
              :style="{
                color: dark ? 'white' : 'black !important',
              }"
            >
              <h1 class="text-center">Blockables</h1>
              <p
                class="text-center"
                :class="author ? 'mb-0' : ''"
                style="line-height: 1.2"
              >
                <!-- <p class="text-center"> -->
                <strong>#{{ puzzleNumber }}:</strong>
                {{ category }}
                <br />
                <template v-if="author">
                  <br />
                  <em style="font-size: 12px">By {{ author }}</em>
                </template>
              </p>
            </span>
          </v-col>
        </v-row>
        <v-row
          v-if="
            wins.includes(puzzleNumber) && !isCoolMath && today < finaleDate
          "
        >
          <v-col cols="12" class="py-0 d-flex align-center justify-center">
            <p
              class="mb-0"
              :style="{
                color: dark ? 'white' : 'black !important',
              }"
            >
              Tomorrow's puzzle in:
              <b>{{ timeRemaining }}...</b>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-btn
              block
              :color="$colors.blue"
              class="white--text"
              :dark="dark"
              :disabled="wins.includes(puzzleNumber)"
              @click="play()"
            >
              {{
                wins.includes(puzzleNumber)
                  ? "Puzzle solved!"
                  : $route.name == "Home"
                  ? "Play Today's Puzzle"
                  : `Play Puzzle #${puzzleNumber}`
              }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10" class="d-flex align-center justify-center">
            <PlayPastPuzzlesToggle />
          </v-col>
          <v-spacer />
        </v-row>
        <v-row v-if="isApp">
          <v-spacer />
          <v-col cols="8" class="pt-1 d-flex align-center justify-center">
            <Support />
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-col cols="6" class="d-flex align-center justify-center">
            <v-btn
              v-if="$ark.active"
              plain
              :dark="dark"
              @click.native="goToTutorial"
            >
              Tutorial
            </v-btn>
            <v-btn
              v-else
              plain
              :dark="dark"
              @click.native="
                $store.commit('USER/INSTRUCTIONS_DIALOG_SET', true)
              "
            >
              Instructions
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-center">
            <v-btn
              plain
              :dark="dark"
              @click="$store.commit('USER/SETTINGS_DIALOG_SET', true)"
            >
              Settings
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import BlockablesNavbar from "./BlockablesNavbar.vue";
import PlayPastPuzzlesToggle from "./buttons/PlayPastPuzzlesToggle.vue";
import Support from "./buttons/Support.vue";

import { mdiAccount, mdiMenu } from "@mdi/js";

export default {
  components: {
    BlockablesNavbar,
    PlayPastPuzzlesToggle,
    Support,
  },
  data: () => ({
    icons: {
      account: mdiAccount,
      menu: mdiMenu,
    },
    pppActive: false,
    showNavDrawer: 0,
    wins: [],
  }),
  computed: {
    allPuzzles() {
      return true;
    },
    author() {
      return this.$store.state.PUZZLE.metadata.author.name;
    },
    category() {
      return this.$store.state.PUZZLE.metadata.category;
    },
    isApp() {
      return process.env.VUE_APP_DEPLOYMENT_PLATFORM == "blockables.app";
    },
    isCoolMath() {
      return process.env.VUE_APP_DEPLOYMENT_PLATFORM == "coolmath";
    },
    dark() {
      return this.$store.state.USER.settings.dark;
    },
    finaleDate() {
      return process.env.VUE_APP_FINALE_DATE;
    },
    puzzleNumber() {
      return this.getOrdinal(
        this.$route.name == "Home" ? this.today : this.$route.params.d
      );
    },
    timed() {
      return !this.$store.state.USER.settings.untimed;
    },
    timeRemaining() {
      return this.$store.getters["USER/TIME_REMAINING"];
    },
    today() {
      return this.$store.getters["USER/TODAY"](
        process.env.VUE_APP_DEPLOYMENT_PLATFORM
      );
    },
    todayHumanReadable() {
      return this.humanReadable();
    },
    user() {
      return !this.$ark.active && this.$store.state.sb_user;
    },
  },
  async mounted() {
    if (this.user) {
      await this.$store.dispatch("USER/GET_STATS_FROM_DB", this.user);
    }
    await this.getWins();
  },
  methods: {
    getOrdinal(d) {
      let o = null;
      try {
        let debutDate = process.env.VUE_APP_DEBUT_DATE;
        let then = debutDate.split("-");
        then = new Date(then[0], then[1] - 1, then[2]);
        let now = d.split("-");
        now = new Date(now[0], now[1] - 1, now[2]);
        o = Math.round((now - then) / (1000 * 60 * 60 * 24)) + 1;
      } catch {
        o = null;
      }
      return o;
    },
    async getWins() {
      try {
        if (this.user) {
          let wins = this.$store.state.USER.stats.map(s => s.ordinal);
          this.wins = [...wins];
          return;
        }
        let wins = await this.$store.dispatch(
          "LOCAL_STORAGE_GET",
          "blockables-ark-wins"
        );
        if (!wins) {
          wins = [];
        } else {
          wins = JSON.parse(wins);
          if (!wins.length) {
            wins = [];
          }
        }
        this.wins = [...wins];
      } catch {
        this.wins = [];
      }
    },
    goToTutorial() {
      this.$router.push("/how-to-play");
    },
    humanReadable(d) {
      if (!d) {
        d = new Date(
          new Date(this.today).toLocaleString("en-US", {
            timeZone: "GMT",
          })
        );
      } else {
        d = new Date(
          new Date(d).toLocaleString("en-US", {
            timeZone: "GMT",
          })
        );
      }

      let dd = d.getDate();

      const month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ][d.getMonth()];

      return `${month} ${dd}${this.nth(dd)}, ${d.getFullYear()}`;
    },
    nth(d) {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
    async play() {
      this.$analytics?.logEvent("game_start", { timed: this.timed });
      if (
        this.$ark.active &&
        process.env.VUE_APP_DEPLOYMENT_PLATFORM == "arkadium-sdk"
      ) {
        await this.$ark.api.callAsyncSDKFunction("onGameStart");
        await this.$ark.api.callAsyncSDKFunction(
          "onLevelStart",
          this.puzzleNumber
        );
      }
      if (
        this.$ark.active &&
        process.env.VUE_APP_DEPLOYMENT_PLATFORM == "arkadium"
      ) {
        this.$ark.api.handleGameStart();
      }
      if (this.isCoolMath) {
        window.parent.postMessage(
          {
            cm_game_event: true,
            cm_game_evt: "start",
            cm_game_lvl: this.puzzleNumber,
          },
          "*"
        );
      }
      // this.$store.commit("USER/TIMED_SET", method == "timed");
      this.$store.commit("USER/GAME_START", true);
      this.$store.commit("USER/INSTRUCTIONS_DIALOG_SET", false);
    },
  },
};
</script>

<style scoped>
.affix-top {
  align-items: flex-start;
  justify-content: flex-start;
  position: sticky; /* Or 'fixed' if you need it fixed at the top */
  top: 0;
  z-index: 10; /* Ensure it's on top if needed */
}
</style>
